export default {
  header: 'Add assessment test',
  description: 'Select the type of assessment you want to add by clicking one of the buttons.',
  createTable: 'Table',
  createChart: 'Chart',
  createImage: 'Image',
  createFile: 'File',
};
